module.exports = __webpack_public_path__ + "media/images/homes/SalesbyEmployees-9c4d79376ec634dad8dbd4c223f037a4.png";